export const environment = {
  production: false,
  platformApiURL: 'https://api.ltiv1p3.platform.beta.development.hallopflege.net',
  allowDebug: true,
  testUserEmail:'test@relias.de'
};

